import { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import Modal from "react-modal";
import { Modal as AntModal, Spin } from "antd";
import { toast } from "react-toastify";
import { formatNumber } from "../../../components/formatNumber";

const BudgetTemplateList = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getFarmerTemplate } = useHttp();

  const getData = () => {
    getFarmerTemplate(
      {
        url: `/api/budgetTemplate/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          console.log(res);
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const { sendRequest: budgetDelete } = useHttp();

  const handleDelete = (e, farmerInputTemplateId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content:
        "Are you sure you want to delete this farmer Budget template detail?",
      onOk() {
        setDeleteLoading(true);
        budgetDelete(
          {
            url: `/api/budgetTemplate/?orgId=${parseInt(
              localStorage.getItem("orgId")
            )}&farmerInputTemplateId=${farmerInputTemplateId}`,
            method: "DELETE",
          },
          (data) => {
            toast.success("Data deleted successfully");

            setDeleteLoading(false);
            getData();
          },
          (error) => {
            toast.error(error);
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const handleSearch = (e) => {
    var filtertext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item.seasonName?.toLowerCase().includes(filtertext) ||
        item.docNo?.toLowerCase().includes(filtertext) ||
        item.templateName?.toLowerCase().includes(filtertext) ||
        item.ranchName?.toLowerCase().includes(filtertext) ||
        item.cropName?.toLowerCase().includes(filtertext) ||
        item.employeeName?.toLowerCase().includes(filtertext)
    );

    setData(filterdata);

    setCurrentPage(1);
  };

  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    console.log(data);

    const farmerInputTemplateId = data && data.farmerInputTemplateId;

    getDetailView(
      {
        url: `/api/budgetTemplate/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerInputTemplateId=${farmerInputTemplateId}`,
      },
      (res) => {
        console.log("Detail View", res);

        setSelectedData(res);
      }
    );

    //  setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    console.log(expense);
    setSelectedApprovalData(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };
  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    // console.log(approvalStatus);

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId:
          selectedApprovalData && selectedApprovalData.farmerInputTemplateId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: parseInt(localStorage.getItem("orgId")),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/budgetTemplateapproval/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        // getProcurementTemplateDetail();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });

        setApprovalPopupVisible(false);
        setRemark("");
        getData();
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title">Farmer Budget Template Details</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>

        {selectedData && (
          <div className="mx-3">
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Doc No: {selectedData.docNo}
              </p>
              <p className="col-md-6">
                Template Date : {selectedData.templateDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Template Name: {selectedData.templateName}
              </p>
              <p className="col-md-6">
                Field Executive Name : {selectedData.employeeName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Crop Name: {selectedData.cropName}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Season Name: {selectedData.seasonName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Ranch Name: {selectedData.regionName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Template Area: {selectedData.templateArea}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Template Area Unit Name: {selectedData.unitName}
              </p>
            </div>
            <h3 className="text-lg font-medium mt-6">Inputs</h3>

            <table className="table table-bordered table-responsive">
              <thead>
                <tr>
                  {[
                    "Sr No.",
                    "Product",
                    "Product Sub Type",
                    "Product Type",
                    "Farming Stage",
                    "Provided By",
                    "Number of Units",
                    "Unit",
                    "Cost/Unit",
                    "Mark-Up",
                    "Cost/Unit (Farmer)",
                    "Total Cost (Company)",
                    "Total Cost (Farmer)",
                    "Mark-Up Value",
                  ].map((header, idx) => (
                    <th key={idx}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {selectedData.budgetTemplateProductDetails &&
                  selectedData.budgetTemplateProductDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.farmingStage}</td>
                        <td>{itm.providedBy}</td>
                        <td>{itm.quantity}</td>
                        <td>{itm.unitName}</td>
                        <td>{formatNumber(itm.cost)}</td>
                        <td>{formatNumber(itm.markUp)}</td>
                        <td>{formatNumber(itm.costFarmer)}</td>
                        <td>{formatNumber(itm.totalCostFarmer)}</td>
                        <td>{formatNumber(itm.totalCostCompany)}</td>
                        <td>{formatNumber(itm.markUpValue)}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Farmer Budget Template
            </label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                sId(serviceId);
                props.update(false);
              }}
            >
              Add Farmer Budget Template
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered table-responsive text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Template No</th>
                          <th>Budget Template Name</th>
                          <th>Ranch Name</th>
                          <th>Crop Name </th>
                          <th>Executive Name</th>
                          <th>Season</th>
                          <th>Template Area</th>
                          <th>Unit</th>
                          <th>Approval</th>
                          <th>View</th>
                          <th>Edit</th>
                          <th>Delete</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.templateDate}</td>
                                <td>{itm.docNo}</td>
                                <td>{itm.templateName}</td>
                                <td>{itm.ranchName}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.seasonName}</td>
                                <td>{itm.templateArea}</td>
                                <td>{itm.unitName}</td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(itm)}
                                    // disabled={
                                    //   itm.approved === 1 || itm.approved === 2
                                    // }
                                  >
                                    {itm.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : itm.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(itm)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>{" "}
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(itm);
                                      props.addForm(true);
                                    }}
                                    // disabled={
                                    //   itm.approved === 1 || itm.approved === 3
                                    // }
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  {deleteLoading === itm ? (
                                    <Spin />
                                  ) : (
                                    <button
                                      onClick={(e) =>
                                        handleDelete(
                                          e,
                                          itm.farmerInputTemplateId
                                        )
                                      }
                                      disabled={
                                        itm.approved === 1 || itm.approved === 2
                                      }
                                      className="btn"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Farmer Survey Template Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default BudgetTemplateList;
